import { Box, Flex, Switch, Text } from "@radix-ui/themes";
import { useOAuthForm } from "../../OAuthFormContext";

export function AppleAdvancedToggles() {
  const { allowMissingEmail, setAllowMissingEmail } = useOAuthForm();
  return (
    <Box
      p="3"
      style={{
        borderRadius: 8,
        border: "1px solid var(--gray-5)",
      }}
    >
      <Flex justify="between" align="center" gap="3">
        <Box style={{ flex: 1, minWidth: 0 }}>
          <Text size="2" weight="medium" style={{ display: "block" }}>
            Allow users without an email
          </Text>
          <Text size="1" color="gray" style={{ display: "block" }}>
            Apple's "Hide my email" lets users revoke email sharing entirely.
            With this on, we generate a stable synthetic address so the user
            can still sign in.
          </Text>
        </Box>
        <Switch
          checked={allowMissingEmail}
          onCheckedChange={(c) => setAllowMissingEmail(c)}
        />
      </Flex>
    </Box>
  );
}
